
import { create } from "zustand";

export interface IGlobalAppState {
    appName: () => string;
}

export const useAppStore = create<IGlobalAppState>(() => {
    return {
        appName: () => {
            const { hostname } = window.location;

            switch (true) {
                case hostname.includes("inside-fleet"):
                    return "InsideFleet";
                case hostname.includes("localhost"):
                case hostname.includes("carpilot360"):
                    return "CarPilot360";
                default:
                    return "InsideFleet";
            }
        },
    };
});
